import httpClient from '@/http-client'

export const index = (options = {}) => {
  return httpClient
    .get('/api/package-returns', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const searchPackages = (options = {}) => {
  return httpClient
    .get('/api/package-returns/search-packages', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/package-returns', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
  return httpClient
    .get('/api/package-returns/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { index, searchPackages, store, formModel }
